import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CustomButton from '../../components/Custom/Button';
import { OpenInNewIcon, ErrorOutlineIcon } from '../../globals/icons';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      px={2}
    >
      <Paper
        elevation={4}
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 400,
          width: '100%',
          bgcolor: 'background.paper',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" mb={3}>
          Sorry, the page you’re looking for doesn’t exist or has been moved.
        </Typography>
        <CustomButton
          endIcon={<OpenInNewIcon />}
          variant="contained"
          onClick={() => navigate('/')}
        >
          Go to Catalogue
        </CustomButton>
      </Paper>
    </Box>
  );
};

export default NotFoundPage;
